import { h } from "@stencil/core";
import { renderShowcaseProperties } from "../utils";
const state = {};
const render = () => (h("ch-status", { accessibleName: state.accessibleName }));
const showcaseRenderProperties = [
    {
        caption: "Properties",
        properties: [
            {
                id: "accessibleName",
                caption: "Accessible Name",
                value: undefined,
                type: "string"
            }
        ]
    }
];
const showcasePropertiesInfo = [{ name: "accessibleName", defaultValue: undefined, type: "string" }];
export const statusShowcaseStory = {
    properties: showcaseRenderProperties,
    markupWithoutUIModel: {
        react: () => `<ChStatus${renderShowcaseProperties(state, "react", showcasePropertiesInfo)}></ChStatus>`,
        stencil: () => `<ch-status${renderShowcaseProperties(state, "stencil", showcasePropertiesInfo)}></ch-status>`
    },
    render: render,
    state: state
};
